import { api } from "@/lib/http";
import type { User } from "@/types/api";

export interface UserCreate {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: "admin" | "user";
}

export const usersApi = {
  list: () => api.get<User[]>("/api/users"),
  create: (body: UserCreate) => api.post<User>("/api/users", body),
  update: (id: number, body: Partial<UserCreate>) => api.put<User>(`/api/users/${id}`, body),
  remove: (id: number) => api.del<void>(`/api/users/${id}`),
};
